<template>
  <b-modal
    v-model="innerValue"
    @shown="addTermlyScript"
    body-class="px-4 pb-4 pt-0"
    dialog-class="termly-modal"
    size="lg"
    hide-footer
  >
    <div>
      <div name="termly-embed" :data-id="termlyId" data-type="iframe"></div>
    </div>
  </b-modal>
</template>

<script>
import { defineComponent, computed, watch } from "@vue/composition-api";

export default defineComponent({
  name: "TermlyModal",
  emits: ["input"],
  props: {
    value: Boolean,
    termlyId: String,
  },
  setup(props, { emit }) {
    const TERMLY_SCRIPT_ID = "termly-jssdk";

    const innerValue = computed({
      get: () => props.value,
      set: (newValue) => emit("input", newValue),
    });

    watch(innerValue, (show) => {
      if (show) return;

      const script = document.getElementById(TERMLY_SCRIPT_ID);

      if (script) script.remove();
    });

    const addTermlyScript = () => {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.id = TERMLY_SCRIPT_ID;
      script.src = "https://app.termly.io/embed-policy.min.js";

      const head = document.getElementsByTagName("head")[0];
      head.appendChild(script);
    };

    return {
      innerValue,
      addTermlyScript,
    };
  },
});
</script>
